import { defineMessages } from "react-intl";

export const clientsMessages = defineMessages({
  "clients.heading": {
    id: "clients.heading",
    defaultMessage: "Clients",
  },
  "clients.tabs.clients.label": {
    id: "clients.tabs.clients.label",
    defaultMessage: "Clients",
  },
  "clients.tabs.sessions.label": {
    id: "clients.tabs.sessions.label",
    defaultMessage: "Sessions",
  },
  "clients.title": {
    id: "clients.title",
    defaultMessage: "Clients",
  },
  "clients.title.count.badge": {
    id: "clients.title.count.badge",
    defaultMessage: `{count, plural, =0 {No Clients} =1 {# Client} other {# Clients}}`,
  },
  "clients.sub": {
    id: "clients.sub",
    defaultMessage: "Here you can see the list of your current clients",
  },
  "clients.add": {
    id: "clients.add",
    defaultMessage: "Add member",
  },
  "clients.table.col.name": {
    id: "clients.table.col.name",
    defaultMessage: "Name",
  },
  "clients.table.col.lastSession": {
    id: "clients.table.col.lastSession",
    defaultMessage: "Last session",
  },
  "clients.table.col.nextSession": {
    id: "clients.table.col.nextSession",
    defaultMessage: "Next session",
  },
  "clients.table.col.action": {
    id: "clients.table.col.action",
    defaultMessage: "Action",
  },
  "clients.table.action.contact": {
    id: "clients.table.action.contact",
    defaultMessage: "Contact client",
  },
  "clients.table.action.decline": {
    id: "clients.table.action.decline",
    defaultMessage: "Decline client",
  },
  "clients.decline.title": {
    id: "clients.decline.title",
    defaultMessage: "Are you sure you want to decline {name}?",
  },
  "clients.decline.yes": {
    id: "clients.decline.yes",
    defaultMessage: "Yes, decline",
  },
  "clients.decline.no": {
    id: "clients.decline.no",
    defaultMessage: "No, cancel",
  },
  "clients.upcoming.all-sessions": {
    id: "clients.upcoming.all-sessions",
    defaultMessage: "All upcoming sessions",
  },
  "clients.upcoming.with-name": {
    id: "clients.upcoming.with-name",
    defaultMessage: "Upcoming sessions with {name}",
  },
  "clients.upcoming.decline-session": {
    id: "clients.upcoming.decline-session",
    defaultMessage: "Cancel",
  },
  "clients.upcoming.decline-session.tooltip.less-than-24-hours": {
    id: "clients.upcoming.decline-session.tooltip.less-than-24-hours",
    defaultMessage:
      "Less than 24 hours left. Cancellation or rescheduling is no longer possible.",
  },
  "clients.upcoming.decline-session.confirm.title": {
    id: "clients.upcoming.decline-session.confirm.title",
    defaultMessage:
      "Are you sure you want to decline session on {date} with {name} ({username})?",
  },
  "clients.upcoming.decline-session.confirm.keep": {
    id: "clients.upcoming.decline-session.confirm.keep",
    defaultMessage: "Keep session",
  },
  "clients.upcoming.decline-session.confirm.decline": {
    id: "clients.upcoming.decline-session.confirm.decline",
    defaultMessage: "Yes, cancel session",
  },
  "clients.upcoming.decline-private-session.confirm.title": {
    id: "clients.upcoming.decline-private-session.confirm.title",
    defaultMessage: "Are you sure you want to decline session on {date}?",
  },

  "clients.add-client.modal.title": {
    id: "clients.add-client.modal.title",
    defaultMessage: "Add new member",
  },
  "clients.add-client.modal.desc": {
    id: "clients.add-client.modal.desc",
    defaultMessage: " ",
  },
  "clients.add-client.fields.firstName": {
    id: "clients.add-client.fields.firstName",
    defaultMessage: "First name",
  },
  "clients.add-client.fields.lastName": {
    id: "clients.add-client.fields.lastName",
    defaultMessage: "Last name",
  },
  "clients.add-client.fields.email": {
    id: "clients.add-client.fields.email",
    defaultMessage: "Email",
  },
  "clients.add-client.fields.locale": {
    id: "clients.add-client.fields.locale",
    defaultMessage: "Select language",
  },
  "clients.add-client.fields.isTrial": {
    id: "clients.add-client.fields.isTrial",
    defaultMessage: "Trial user",
  },
  "clients.add-client.cancel": {
    id: "clients.add-client.cancel",
    defaultMessage: "Cancel",
  },
  "clients.add-client.submit": {
    id: "clients.add-client.submit",
    defaultMessage: "Send invite",
  },
  "clients.sessions.table.col.time": {
    id: "clients.sessions.table.col.time",
    defaultMessage: "Date",
  },
  "clients.sessions.table.col.name": {
    id: "clients.sessions.table.col.name",
    defaultMessage: "Name",
  },
  "clients.sessions.table.col.status": {
    id: "clients.sessions.table.col.status",
    defaultMessage: "Status",
  },
  "clients.sessions.table.col.action": {
    id: "clients.sessions.table.col.action",
    defaultMessage: "Action",
  },
  "clients.sessions.title": {
    id: "clients.sessions.title",
    defaultMessage: "Sessions",
  },
  "clients.sessions.title.count.badge": {
    id: "clients.sessions.title.count.badge",
    defaultMessage: `{count, plural, =0 {No Sessions} =1 {# Session} other {# Sessions}}`,
  },
  "clients.sessions.sub": {
    id: "clients.sessions.sub",
    defaultMessage: "Here you can see the list of your client sessions",
  },
  "clients.sessions.filter.client": {
    id: "clients.sessions.filter.client",
    defaultMessage: "Client",
  },
  "clients.sessions.filter.client.all": {
    id: "clients.sessions.filter.client.all",
    defaultMessage: "All clients",
  },
  "clients.sessions.filter.status.all": {
    id: "clients.sessions.filter.status.all",
    defaultMessage: "All statuses",
  },
  "clients.sessions.filter.status": {
    id: "clients.sessions.filter.status",
    defaultMessage: "Status",
  },
  "clients.sessions.filter.status.completed": {
    id: "clients.sessions.filter.status.completed",
    defaultMessage: "Completed",
  },
  "clients.sessions.filter.status.upcoming": {
    id: "clients.sessions.filter.status.upcoming",
    defaultMessage: "Upcoming",
  },
  "clients.sessions.filter.status.canceled": {
    id: "clients.sessions.filter.status.canceled",
    defaultMessage: "Canceled",
  },
  "clients.sessions.filter.status.pending": {
    id: "clients.sessions.filter.status.pending",
    defaultMessage: "Pending",
  },
  "clients.sessions.filter.time": {
    id: "clients.sessions.filter.time",
    defaultMessage: "All time",
  },
  "clients.sessions.filter.time.from": {
    id: "clients.sessions.filter.time.from",
    defaultMessage: "From",
  },
  "clients.sessions.filter.time.to": {
    id: "clients.sessions.filter.time.to",
    defaultMessage: "To",
  },
  "clients.sessions.action.resolve": {
    id: "clients.sessions.action.resolve",
    defaultMessage: "Completed",
  },
  "clients.sessions.action.resolve.completed": {
    id: "clients.sessions.action.resolve.completed",
    defaultMessage: "Completed",
  },
  "clients.sessions.action.resolve.canceled": {
    id: "clients.sessions.action.resolve.canceled",
    defaultMessage: "Client did not show",
  },
  "clients.sessions.action.resolve.completed.confirm.desc": {
    id: "clients.sessions.action.resolve.completed.confirm.desc",
    defaultMessage: "Are you sure you want to mark this session as completed?",
  },
  "clients.sessions.action.resolve.canceled.confirm.desc": {
    id: "clients.sessions.action.resolve.canceled.confirm.desc",
    defaultMessage: "Are you sure you want to mark this session as canceled?",
  },
});
